import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54451338"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slideout-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["slideout-container", { show: $props.show }]),
    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
  }, [
    _createElementVNode("div", {
      class: "slideout",
      ref: "slideout",
      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('close')), ["esc"])),
      tabindex: "0",
      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
    }, [
      ($props.showClose)
        ? (_openBlock(), _createBlock($setup["CloseButton"], {
            key: 0,
            onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ], 544 /* HYDRATE_EVENTS, NEED_PATCH */)
  ], 2 /* CLASS */))
}